var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.editable)?_c('div',[_c('input',{ref:"gg-autocomplete",staticClass:"uk-width-1-1",class:{'uk-form-warning': _vm.highlighted&&_vm.required&&!_vm.one_liner},attrs:{"type":"text","placeholder":"Address"},domProps:{"value":_vm.one_liner},on:{"change":_vm.data_changed}})]):_c('div',[_vm._v(" "+_vm._s(_vm.one_liner)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }